import React from 'react'
import "./Loader.css"


export default function Loader(){
    return <div className="spinner-wrapper">
      <div className="spinner-loader"> </div>
    </div>
  }
